import * as React from "react";
const SvgPlusWhite = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 1L5 9M9 5L1 5", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgPlusWhite;
